// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MoMoycF1g5tBrt {\n  margin-left: 4px;\n}\n._3gWX-1xRe0OrDJ {\n  background-color: transparent;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desktopSettingsButton": "MoMoycF1g5tBrt",
	"headerButton": "_3gWX-1xRe0OrDJ"
};
export default ___CSS_LOADER_EXPORT___;
